export const CHIP_SIZE_MODIFIERS = {
  xs: 'd-chip__label--xs',
  sm: 'd-chip__label--sm',
  md: '',
};

export const CHIP_CLOSE_BUTTON_SIZE_MODIFIERS = {
  xs: 'd-chip__close--xs',
  sm: 'd-chip__close--sm',
  md: '',
};

export const CHIP_ICON_SIZES = {
  xs: '200',
  sm: '200',
  md: '200',
};

export default {
  CHIP_SIZE_MODIFIERS,
  CHIP_CLOSE_BUTTON_SIZE_MODIFIERS,
  CHIP_ICON_SIZES,
};
